import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=b3f4321e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3f4321e')) {
      api.createRecord('b3f4321e', component.options)
    } else {
      api.reload('b3f4321e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=b3f4321e&", function () {
      api.rerender('b3f4321e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wI6B5znPJXCu/JS/comp/openstreetmap.vue"
export default component.exports